/**
 * This file is kept for backward compatibility and to avoid updating every import in the Web app.
 * All new analytics-related code should live in and be imported directly from "@punchup/analytics".
 */

export * from "./mixpanel";
export * from "./mixpanel.types";
